import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectSprayEventForSubmissionApplicationType } from 'services/sprayEventsForSubmission/selectors';
import { getSprayEventApplicationTypeDisplay } from 'services/sprayEvents/utils';

const selectApplicationTypeDisplay = createDeepEqualSelector(
    makeSelectSprayEventForSubmissionApplicationType(),
    (sprayEventApplicationType) => {
        return getSprayEventApplicationTypeDisplay(sprayEventApplicationType);
    }
);
export { selectApplicationTypeDisplay };
